import ModelBuilder from 'helpers/ModelBuilder';
import { EntityBase, EntityLike } from './EntityBase';

export class Discount extends EntityBase {
  discountId: string;
  loyaltyNumber: string;
  discountCode: string;

  static Model: typeof ModelDefinition;

  static new(object: EntityLike<Discount>) {
    return super.fill(this, object);
  }
};

const fields = ModelBuilder.buildFormFields<Discount>({
  discountId: { label: 'Discount', placeholder: 'Select discount type' },
  loyaltyNumber: { label: 'Loyalty' },
  discountCode: { label: 'Discount Code' },
});

class ModelDefinition {
  static fields = fields;
}
Discount.Model = ModelDefinition;
